export const slackData = {
  overview: {
    totalMessages: 2123,
    dateRange: "09/01/2024 - 11/07/2024",
    activeUsers: 27,
    activeChannels: 10,
    avgMessagesPerUser: 79,
    totalReactions: 476,
    activeDays: 100
  },
  topContributors: [
    { rank: 1, user: "Louise", messages: 423, reactions: 67, channels: 8 },
    { rank: 2, user: "se.legoff", messages: 324, reactions: 36, channels: 8 },
    { rank: 3, user: "Sébastien Di Mauro", messages: 305, reactions: 41, channels: 8 },
    { rank: 4, user: "Benjamin Chatelain", messages: 268, reactions: 61, channels: 7 },
    { rank: 5, user: "Laura Jacquin", messages: 179, reactions: 103, channels: 8 },
    { rank: 6, user: "JP Roemer", messages: 151, reactions: 13, channels: 6 },
    { rank: 7, user: "Romain Vermot", messages: 134, reactions: 16, channels: 7 },
    { rank: 8, user: "Antoine Andreu", messages: 77, reactions: 22, channels: 3 },
    { rank: 9, user: "thibault Le Balier", messages: 58, reactions: 31, channels: 6 },
    { rank: 10, user: "Camille Jacoulot", messages: 38, reactions: 25, channels: 3 },
    { rank: 11, user: "Stéphane De Magalhaes", messages: 35, reactions: 32, channels: 3 },
    { rank: 12, user: "Eric Lassus", messages: 30, reactions: 1, channels: 5 },
    { rank: 13, user: "deajace99", messages: 22, reactions: 2, channels: 5 },
    { rank: 14, user: "Oussama Benmansour", messages: 19, reactions: 1, channels: 5 },
    { rank: 15, user: "Deborah jace", messages: 15, reactions: 6, channels: 4 }
  ],
  channelActivity: [
    { channel: "sales", messages: 842 },
    { channel: "tech", messages: 630 },
    { channel: "product", messages: 515 },
    { channel: "general", messages: 46 },
    { channel: "random", messages: 32 },
    { channel: "user_interviews", messages: 24 },
    { channel: "sentry", messages: 20 },
    { channel: "github", messages: 11 },
    { channel: "metabase_files", messages: 2 },
    { channel: "veille-marché", messages: 1 }
  ],
  hourlyActivity: [
    { hour: 0, messages: 0 },
    { hour: 1, messages: 0 },
    { hour: 2, messages: 0 },
    { hour: 3, messages: 0 },
    { hour: 4, messages: 0 },
    { hour: 5, messages: 0 },
    { hour: 6, messages: 5 },
    { hour: 7, messages: 18 },
    { hour: 8, messages: 89 },
    { hour: 9, messages: 156 },
    { hour: 10, messages: 198 },
    { hour: 11, messages: 234 },
    { hour: 12, messages: 167 },
    { hour: 13, messages: 201 },
    { hour: 14, messages: 289 },
    { hour: 15, messages: 313 },
    { hour: 16, messages: 278 },
    { hour: 17, messages: 156 },
    { hour: 18, messages: 89 },
    { hour: 19, messages: 34 },
    { hour: 20, messages: 12 },
    { hour: 21, messages: 8 },
    { hour: 22, messages: 3 },
    { hour: 23, messages: 1 }
  ],
  monthlyActivity: [
    { month: "Jan 2024", messages: 1020 },
    { month: "Feb 2024", messages: 497 },
    { month: "Mar 2024", messages: 161 },
    { month: "Apr 2024", messages: 31 },
    { month: "May 2024", messages: 337 },
    { month: "Jun 2024", messages: 69 },
    { month: "Jul 2024", messages: 8 }
  ]
};

export const axes = [
  {
    id: "axe1",
    numero: 1,
    nom: "Charge de travail",
    categories: {
      "HR Data": [
        {
          donnee: "Heures supplémentaires",
          source: "GTA / Pointage ; SIRH Temps ; Paie",
          extraction: "Export CSV/Excel Heures sup ; API /timesheets /overtime ; rapport SFTP planifié",
          exemples_logiciels: "UKG (Kronos/Dimensions), Kelio (Bodet), Horoquartz eTemptation, Lucca Timmi, Octime, ADP Time",
          champs_typiques: "employee_id, team, period, ot_hours, ot_occurrences, approval_status",
        },
        {
          donnee: "Données de pointage (début/fin, pauses)",
          source: "Badgeuses/Terminals ; GTA ; SIRH Temps",
          extraction: "Export punches attendance detail ; API /attendance /punches ; journaux SFTP",
          exemples_logiciels: "UKG, Kelio, Horoquartz, Timmi, When I Work",
          champs_typiques: "employee_id, date, first_checkin, last_checkout, break_minutes, anomalies",
        },
        {
          donnee: "Utilisation des congés (soldes/prises)",
          source: "SIRH Congés & Absences ; Paie",
          extraction: "Export Soldes & prises ; API /leaves /balances /requests ; SFTP mensuel",
          exemples_logiciels: "SAP SuccessFactors, Workday, Oracle HCM, Lucca (Timmi Absences), Personio, BambooHR",
          champs_typiques: "employee_id, leave_type, leave_balance_days, leave_taken_days, start_date, end_date, status",
        },
        {
          donnee: "Entretiens annuels/professionnels",
          source: "Outils Performance/Entretiens ; SIRH Talent",
          extraction: "Export CSV/PDF des entretiens ; API /performance/reviews /goals ; export verbatim",
          exemples_logiciels: "Lattice, Leapsome, Culture Amp, SuccessFactors PM/GM, Cornerstone (Talentsoft)",
          champs_typiques: "employee_id, review_date, goals_count, workload_self_rating(1-5), review_sentiment(-1..1), verbatim",
        },
        {
          donnee: "Descriptions de poste",
          source: "Référentiel postes SIRH ; ATS",
          extraction: 'Export "Job Catalog" CSV/JSON ; API /job_profiles /job_reqs',
          exemples_logiciels: "Workday Job Profiles, SAP SF Job Descriptions, Greenhouse, Lever, SmartRecruiters",
          champs_typiques: "job_code, job_title, missions, responsibilities, clarity_score(1-5)",
        },
        {
          donnee: "Télétravail (fréquence/charte/satisfaction)",
          source: "SIRH (déclarations & accords) ; Outils enquête QVT ; Analytics (Viva/Workspace)",
          extraction: "Export déclarations hebdo/mensuelles ; API /remote_work /attendance_location ; export enquêtes",
          exemples_logiciels: "Workday (Work Location), Lucca (Télétravail), Microsoft Viva Insights, Qualtrics, Culture Amp",
          champs_typiques: "employee_id, week_start, remote_days_per_week, policy_version, remote_satisfaction(1-5)",
        },
        {
          donnee: "Demandes de mobilité interne",
          source: "SIRH Carrière/Talent ; ATS interne",
          extraction: "Export candidatures internes ; API /internal_applications /mobility_requests",
          exemples_logiciels: "Workday (Internal Job Posts), SAP SF (RMK/RBP), Cornerstone (Talentsoft), 365Talents",
          champs_typiques: "employee_id, request_date, target_job_code, reason_category, status, comment",
        },
        {
          donnee: "Absentéisme court (< 3 jours) – indicateur de fatigue",
          source: "SIRH Congés/Absences ; GTA/Pointage ; Paie",
          extraction: 'Export CSV/Excel "Absences <3j" ; API /leaves /absences ; rapports SFTP mensuels',
          exemples_logiciels: "Workday, SAP SuccessFactors, Oracle HCM, Lucca (Timmi Absences), Personio, ADP",
          champs_typiques: "employee_id, date, absence_type, duration_days, is_short_leave(<3), reason_code, team, recurrence_count_90d",
        },
        {
          donnee: "Déclarations d'AT/MP (TMS)",
          source: "Registre AT/MP ; HSE/EHS ; Portail net-entreprises / Compte AT/MP (ameli) ; Paie/DSN",
          extraction: "Export registre AT/MP (CSV/PDF) ; API EHS (/incidents, /injuries) ; extraction DSN (codes risques)",
          exemples_logiciels: "Enablon, Quentic, Intelex, Sphera ; Portail AT/MP ameli / net-entreprises ; ADP, Sage Paie",
          champs_typiques: "incident_id, employee_id, incident_date, nature_lesion, agent_cause, body_part, is_TMS, severity, work_stop_days, declaration_ref, status",
        },
        {
          donnee: "Visites médicales (inaptitudes partielles, alertes médecin)",
          source: "Service de Prévention & Santé au Travail (SPST) – portail externe ; SIRH Dossier salarié (suivi VM)",
          extraction: "Export planning & comptes-rendus (CSV/PDF) ; API/échanges SFTP fournis par SPST ; imports SIRH",
          exemples_logiciels: "Padoa (portail SPST), Medtra, logiciel SPST local ; Workday/SAP SF (suivi VM interne)",
          champs_typiques: "employee_id, visit_type(embauche/périodique/reprise), visit_date, aptitude(apte/inapte/apt. partielle), restrictions, next_due_date, alerts_flag",
        },
        {
          donnee: "DUERP – risques (charge, gestes/postures)",
          source: "Outils DUERP / EHS ; Documentation HSE ; Référentiel risques",
          extraction: "Export évaluations des risques (CSV/JSON) ; API /risk_assessments ; rapports PDF",
          exemples_logiciels: "Enablon, Quentic, IsoMetrix, HSE Manager, MyDUERP",
          champs_typiques: "risk_id, unit_of_work, risk_category(charge mentale/TMS/postures), probability, severity, criticality, measures_planned, owner, review_date",
        },
      ],
      "Data SantéPrévention": [
        {
          donnee: "Absentéisme court (< 3 jours) – indicateur de fatigue",
          source: "SIRH Congés/Absences ; GTA/Pointage ; Paie",
          extraction: 'Export CSV/Excel "Absences <3j" ; API /leaves /absences ; rapports SFTP mensuels',
          exemples_logiciels: "Workday, SAP SuccessFactors, Oracle HCM, Lucca (Timmi Absences), Personio, ADP",
          champs_typiques: "employee_id, date, absence_type, duration_days, is_short_leave(<3), reason_code, team, recurrence_count_90d",
        },
        {
          donnee: "Déclarations d'AT/MP (TMS)",
          source: "Registre AT/MP ; HSE/EHS ; Portail net-entreprises / Compte AT/MP (ameli) ; Paie/DSN",
          extraction: "Export registre AT/MP (CSV/PDF) ; API EHS (/incidents, /injuries) ; extraction DSN (codes risques)",
          exemples_logiciels: "Enablon, Quentic, Intelex, Sphera ; Portail AT/MP ameli / net-entreprises ; ADP, Sage Paie",
          champs_typiques: "incident_id, employee_id, incident_date, nature_lesion, agent_cause, body_part, is_TMS, severity, work_stop_days, declaration_ref, status",
        },
        {
          donnee: "Visites médicales (inaptitudes partielles, alertes médecin)",
          source: "Service de Prévention & Santé au Travail (SPST) – portail externe ; SIRH Dossier salarié (suivi VM)",
          extraction: "Export planning & comptes-rendus (CSV/PDF) ; API/échanges SFTP fournis par SPST ; imports SIRH",
          exemples_logiciels: "Padoa (portail SPST), Medtra, logiciel SPST local ; Workday/SAP SF (suivi VM interne)",
          champs_typiques: "employee_id, visit_type(embauche/périodique/reprise), visit_date, aptitude(apte/inapte/apt. partielle), restrictions, next_due_date, alerts_flag",
        },
        {
          donnee: "DUERP – risques (charge, gestes/postures)",
          source: "Outils DUERP / EHS ; Documentation HSE ; Référentiel risques",
          extraction: "Export évaluations des risques (CSV/JSON) ; API /risk_assessments ; rapports PDF",
          exemples_logiciels: "Enablon, Quentic, IsoMetrix, HSE Manager, MyDUERP",
          champs_typiques: "risk_id, unit_of_work, risk_category(charge mentale/TMS/postures), probability, severity, criticality, measures_planned, owner, review_date",
        },
      ],
      IndicateursIndirects: [
        {
          donnee: "Taux d'erreur / non-qualité",
          source: "ERP/MES, WMS, LIMS, Helpdesk/Ticketing",
          extraction: "Exports qualité (CSV), API /defects /nc /tickets, SFTP mensuel",
          exemples_logiciels: "SAP/Oracle ERP, Microsoft Dynamics 365, Odoo, Enablon/Quentic (Qualité), Zendesk/Jira Service Management",
          champs_typiques: "period, process, team, total_units, defects, error_rate_pct, top_error_codes, source_system",
        },
        {
          donnee: "Délais de production / livraison (flux)",
          source: "MES/ERP (prod), TMS/WMS (logistique)",
          extraction: "Exports SLA/lead time, API /orders /shipments /kpi, requêtes BI",
          exemples_logiciels: "SAP ME/MII, Siemens OpCenter, Kinaxis; TMS (Shippeo, Transporeon), WMS (Manhattan, Reflex)",
          champs_typiques: "period, flow, team, orders, avg_lead_time_days, p95_lead_time_days, sla_target_days, sla_breaches, source_system",
        },
        {
          donnee: "Verbatim réunions d'équipe",
          source: "Comptes-rendus (docs), enregistrements (Teams/Meet/Zoom), Notion/Confluence",
          extraction: "Export texte/PDF, API transcriptions (Teams/Meet/Zoom), export Notion/Confluence",
          exemples_logiciels: "Microsoft Teams/Loop, Google Meet, Zoom, Notion, Confluence, Fireflies.ai, Otter.ai",
          champs_typiques: "meeting_id, date, team, topics[], verbatim, sentiment, tags[], source",
        },
        {
          donnee: "Utilisation des logiciels métiers (adoption/contournements)",
          source: "Analytics applicatifs (ERP/CRM/WMS), SIEM, logs d'audit",
          extraction: "Exports usage/licences, API /usage /audit /events, connecteurs BI",
          exemples_logiciels: "Salesforce Adoption, HubSpot, SAP Usage Analytics, Power BI audit logs, Splunk/Elastic",
          champs_typiques: "app, module, team, active_users, licensed_users, adoption_rate_pct, bypass_signals_per_week, common_bypass, source",
        },
        {
          donnee: "Signaux faibles (fatigue/irritabilité/somatique)",
          source: "Micro-sondages, formulaires anonymes, baromètres flash",
          extraction: "Export CSV/JSON enquêtes, API survey /responses",
          exemples_logiciels: "Qualtrics, Culture Amp, Google Forms, Typeform, Slido",
          champs_typiques: "period, team, sample_size, fatigue_persistante_pct, irritabilite_pct, plaintes_somatiques_pct, free_text, source",
        },
      ],
    },
  },
  {
    id: "axe2",
    numero: 2,
    nom: "Management & soutien social",
    categories: {
      "HR Data": [
        {
          donnee: "Taux de turnover (dont nouveaux < 1 an)",
          source: "SIRH Core HR, Paie, Offboarding",
          extraction: "Exports headcount/mouvements (CSV), API /workers /employment /terminations, SFTP mensuel",
          exemples_logiciels: "Workday HCM, SAP SuccessFactors, Oracle HCM, Personio, BambooHR",
          champs_typiques: "period, team, headcount_avg, hires, separations, separations_lt1yr, turnover_rate_pct, new_hire_turnover_rate_pct",
        },
        {
          donnee: "Résultats enquêtes d'engagement (ENPS)",
          source: "Plateformes d'enquêtes",
          extraction: "Export CSV/JSON, API /surveys /results /drivers",
          exemples_logiciels: "Workday Peakon, Qualtrics, Culture Amp, Leapsome, Lattice",
          champs_typiques: "period, team, responses, enps_score, favorable_pct, neutral_pct, unfavorable_pct, key_drivers",
        },
        {
          donnee: "Verbatim des entretiens de départ",
          source: "SIRH offboarding, notes RH (docs)",
          extraction: "Export PDF/CSV/JSON, API /exits /interviews, extraction depuis DMS",
          exemples_logiciels: "Workday/SAP Offboarding, Notion/Confluence, SharePoint",
          champs_typiques: "interview_id, employee_id, team, date, tenure_months, primary_reasons[], manager_related, vision_related, sentiment, verbatim",
        },
        {
          donnee: "Taux de participation aux formations managériales",
          source: "LMS / LXP",
          extraction: "Export inscriptions/achèvements CSV, API /courses /enrollments /completions",
          exemples_logiciels: "Cornerstone, 360Learning, Docebo, SAP Litmos",
          champs_typiques: "period, course_id, course_title, target_population, team, enrolled, completed, no_show, completion_rate_pct, no_show_rate_pct, lms_source",
        },
        {
          donnee: "Évaluations 360° des managers",
          source: "Outils 360 / Performance",
          extraction: "Export résultats 360, API /360 /feedback",
          exemples_logiciels: "Leapsome 360, Lattice 360, Culture Amp 360, Spidergap",
          champs_typiques:
            "period, manager_id, manager_name, team, participants, response_rate_pct, leadership, communication, feedback, workload_mgmt, psych_safety, overall_score, percentile",
        },
        {
          donnee: "Taux de promotion interne vers management",
          source: "SIRH Talent/Carrière",
          extraction: "Export mouvements internes, API /promotions /job_changes",
          exemples_logiciels: "Workday, SAP SuccessFactors, Oracle HCM",
          champs_typiques: "period, team, promotions_to_management, eligible_pool, promotion_rate_pct, median_time_to_promotion_months, internal_vs_external_ratio",
        },
      ],
      "Data SantéPrévention": [
        {
          donnee: "Taux d'absentéisme par équipe/manager",
          source: "SIRH Absences, GTA/Pointage, Paie",
          extraction: "Exports mensuels (CSV), API /absences /leaves /attendance, SFTP",
          exemples_logiciels: "Workday, SAP SF, Oracle HCM, Lucca, ADP",
          champs_typiques: "period, team, manager_id, manager_name, headcount_days, absence_days, absenteeism_rate_pct, short_leave_days, stress_related_days",
        },
        {
          donnee: "Consultations au service de santé (stress/anxiété/conflits)",
          source: "SPST (portail externe), DMS RH, SIRH (suivi)",
          extraction: "Exports agrégés CSV/JSON, interfaces SFTP SPST, API si dispo",
          exemples_logiciels: "Padoa (SPST), Medtra, logiciels SPST, Workday (suivi)",
          champs_typiques: "period, team, consult_reason, consultations_count, unique_employees, followup_required, referred_to_psych, source",
        },
        {
          donnee: "DUERP – RPS (management/soutien)",
          source: "Outils DUERP / EHS ; référentiel risques",
          extraction: "Export évaluations (CSV/JSON), API /risk_assessments, rapports PDF",
          exemples_logiciels: "Enablon, Quentic, IsoMetrix, MyDUERP",
          champs_typiques: "risk_id, unit_of_work, rps_factor, probability, severity, criticality, risk_level, measures_planned, owner, review_date",
        },
        {
          donnee: "Rapports des assistantes sociales",
          source: "DMS RH, outil d'action sociale, SharePoint/Drive",
          extraction: "Export JSON/CSV anonymisé ; modèles standardisés ; chiffrement",
          exemples_logiciels: "Notion/Confluence/SharePoint ; outil interne d'action sociale",
          champs_typiques: "case_id, date, team, theme, risk_level, actions[], follow_up, notes",
        },
      ],
      IndicateursIndirects: [
        {
          donnee: "Conflits / médiations gérés par les RH",
          source: "Outils de ticketing RH, DMS RH",
          extraction: "Exports CSV/Excel, API /cases /mediations, SFTP mensuel",
          exemples_logiciels: "Zendesk/Jira Service Mgmt (HR), ServiceNow HR, Freshservice",
          champs_typiques: "period, team, cases_opened, mediations_started, mediations_successful, avg_time_to_resolution_days, escalations_to_legal, source",
        },
        {
          donnee: "Verbatim des enquêtes de satisfaction",
          source: "Plateformes d'enquêtes",
          extraction: "Export JSON/CSV, API /surveys /responses /text",
          exemples_logiciels: "Qualtrics, Culture Amp, Peakon (Workday), Leapsome, Typeform",
          champs_typiques: "response_id, period, team, themes[], sentiment, verbatim",
        },
        {
          donnee: "Taux d'adoption des outils de com interne",
          source: "Analytics web/intranet, ESP newsletters",
          extraction: "Exports usage/licences, API /usage /events /email, logs d'audit",
          exemples_logiciels: "SharePoint/Power BI (Intranet), LumApps, Google Analytics/GA4, Mailchimp/Sendinblue",
          champs_typiques: "period, channel, team, monthly_active_users, eligible_users, adoption_rate_pct, avg_sessions_per_user, bounce_rate_pct, source",
        },
        {
          donnee: "Participation aux événements d'entreprise",
          source: "Outils d'inscription/présence, Excel/HRIS",
          extraction: "Export CSV, API /events /attendees",
          exemples_logiciels: "Eventbrite/Bizzabo, Lucca Figgo Événements, Google Forms + Sheets",
          champs_typiques: "event_id, event_name, date, location, target_pop, invited, registered, attended, attendance_rate_pct, no_show, source",
        },
        {
          donnee: "Signaux faibles (repli, résignation, cynisme)",
          source: "Micro-sondages, formulaires anonymes, baromètres flash",
          extraction: "Export CSV/JSON, API /pulse",
          exemples_logiciels: "Culture Amp, Qualtrics, Slido, Typeform, Google Forms",
          champs_typiques: "period, team, sample_size, repli_social_pct, resignation_discourse_pct, cynisme_pct, free_text, source",
        },
      ],
    },
  },
  {
    id: "axe3",
    numero: 3,
    nom: "Égalité professionnelle",
    categories: {
      "HR Data": [
        {
          donnee: "Index égalité professionnelle F/H",
          source: "BDESE, Paie, SIRH Core HR",
          extraction: "Export BDESE/Paie CSV ; API /compensation /promotions ; rapports légaux",
          exemples_logiciels: "Workday, SAP SF, Oracle HCM, ADP, Pagga Paie (Lucca)",
          champs_typiques:
            "year, company_unit, score_total, pay_gap_score, raise_gap_score, promotion_gap_score, maternity_return_raise_score, top10_highest_paid_gender_balance_score",
        },
        {
          donnee: "Écarts de rémunération (genre, âge, poste)",
          source: "Paie, SIRH Compensation",
          extraction: "Export rémunérations (CSV) ; API /compensation ; SFTP",
          exemples_logiciels: "ADP, Sage Paie, SAP SuccessFactors Comp, Workday Comp",
          champs_typiques: "period, team, job_level/poste, age_band, avg_m_brut_M/F, median_brut_M/F, gap_pct",
        },
        {
          donnee: "Répartition des promotions (genre, âge)",
          source: "SIRH Talent/Carrière",
          extraction: "Export mouvements internes ; API /promotions /job_changes",
          exemples_logiciels: "Workday, SAP SF, Oracle HCM",
          champs_typiques: "year, team, age_band, promoted_M/F, eligible_M/F, promotion_rate_M/F_pct",
        },
        {
          donnee: "Accès à la formation (heures/budget)",
          source: "LMS/LXP, SIRH Formation",
          extraction: "Export inscriptions/achèvements, API /enrollments /completions",
          exemples_logiciels: "Cornerstone, 360Learning, Docebo, SAP Litmos",
          champs_typiques: "period, team, gender, contract_type, work_time, trainees, hours_total, budget_eur, avg_hours_per_person, avg_budget_per_person",
        },
        {
          donnee: "Données temps partiel (subi/choisi)",
          source: "SIRH Temps & Contrats, Paie",
          extraction: "Export effectifs contrats/temps ; API /contracts",
          exemples_logiciels: "Workday, SAP SF, Personio, BambooHR",
          champs_typiques: "period, team, gender, part_time_headcount, chosen_pct, subi_pct, top_reasons_chosen, top_reasons_subi",
        },
        {
          donnee: "Recrutement — diversité des candidatures",
          source: "ATS",
          extraction: "Export pipeline ; API /applications /stages",
          exemples_logiciels: "Greenhouse, Lever, SmartRecruiters, Taleo, Workable",
          champs_typiques: "period, job_family, stage, applications_total, applications_F/M, age_<30/30_39/40_49/50plus, source",
        },
      ],
    },
  },
  {
    id: "axe4",
    numero: 4,
    nom: "Dialogue social & participation",
    categories: {
      "HR Data": [
        {
          donnee: "Nombre & thèmes des accords d'entreprise",
          source: "BDESE, archives RH, DMS",
          extraction: "Export BDESE/CSV, index doc, API DMS",
          exemples_logiciels: "Workday, SAP SF, SharePoint, Notion",
          champs_typiques: "year, agreement_type, themes[], status, signatory_unions, renewal_due",
        },
        {
          donnee: "Taux de participation aux élections professionnelles",
          source: "Registres CSE, BDESE",
          extraction: "Exports CSV, PV de résultats, OCR si PDF",
          exemples_logiciels: "Workday, Lucca, Excel BDESE",
          champs_typiques: "year, round, registered, voted, participation_rate_pct, valid_ballots, blank_or_null",
        },
        {
          donnee: "Fréquence & CR des réunions CSE",
          source: "Registres/PV CSE",
          extraction: "Export planning, API DMS, OCR PDF",
          exemples_logiciels: "SharePoint, Notion, Dropbox, Workday",
          champs_typiques: "period, meeting_type, meetings_held, expected_meetings, attendance_rate_pct, minutes_published_days, key_topics",
        },
        {
          donnee: "Suivi des avis du CSE",
          source: "Registres CSE, outils suivi actions",
          extraction: "Export actions, API /cases",
          exemples_logiciels: "ServiceNow HR, Jira, Workday",
          champs_typiques: "period, opinion_id, topic, opinion, decision, action_owner, due_date, status",
        },
        {
          donnee: "Participation aux « espaces de discussion »",
          source: "Plateformes d'enquêtes / suivi ateliers",
          extraction: "Export sessions, formulaires",
          exemples_logiciels: "Qualtrics, Typeform, Notion",
          champs_typiques: "period, unit, sessions_planned, sessions_held, participants_total, avg_participants_per_session, themes_top3, satisfaction_avg_1_5",
        },
      ],
      "Data SantéPrévention": [
        {
          donnee: "Alertes CSE « danger grave & imminent »",
          source: "Registres CSE",
          extraction: "Export CSV/PDF, OCR, API si dispo",
          exemples_logiciels: "Enablon/Quentic (registre), DMS",
          champs_typiques: "period, unit, alerts_dgi, avg_time_to_investigation_days, avg_time_to_mitigation_days, closed_with_agreement_pct",
        },
        {
          donnee: "Implication CSE dans l'analyse AT/MP",
          source: "Rapports AT/MP, CSSCT",
          extraction: "Exports EHS, API /incidents",
          exemples_logiciels: "Enablon, Intelex, Sphera",
          champs_typiques: "period, unit, atmp_cases, cse_case_reviews, pct_cases_reviewed_by_cse, recommendations",
        },
        {
          donnee: "Rôle du CSE dans la mise à jour du DUERP",
          source: "Outil DUERP/EHS",
          extraction: "Export évaluations, API /risk_assessments",
          exemples_logiciels: "Enablon, Quentic, IsoMetrix",
          champs_typiques: "period, unit, duerp_updates, cse_sessions_on_risk, pct_duerp_updates_with_cse, topics[]",
        },
      ],
      IndicateursIndirects: [
        {
          donnee: "Conflits collectifs / grèves",
          source: "Historique RH, presse interne",
          extraction: "Export événements, log heures",
          exemples_logiciels: "DMS RH, Excel, Notion",
          champs_typiques: "period, type, unit, events_count, participants_peak, hours_lost, primary_cause, resolution",
        },
        {
          donnee: "Délai de résolution des problèmes remontés",
          source: "Ticketing RH, Boîte à idées",
          extraction: "API /tickets /ideas, exports",
          exemples_logiciels: "ServiceNow HR, Jira, Zendesk",
          champs_typiques: "period, channel, unit, issues_raised, issues_resolved, avg_resolution_days, p95_resolution_days",
        },
        {
          donnee: "Sentiment sur réseaux internes",
          source: "Plateformes collaboratives",
          extraction: "Export posts/comments, API",
          exemples_logiciels: "MS Viva/Yammer, Slack",
          champs_typiques: "period, platform, population, posts, comments, unique_authors, sentiment_avg, neg_ratio_pct, top_topics",
        },
      ],
    },
  },
  {
    id: "axe5",
    numero: 5,
    nom: "Perspectives & évolution de carrière",
    categories: {
      "HR Data": [
        {
          donnee: "Budget formation",
          source: "SIRH Formation, BDESE, Paie",
          extraction: "Export budgets/engagés, API /training/budget",
          exemples_logiciels: "Workday, SAP SF Learning, 360Learning, Cornerstone, Lucca",
          champs_typiques: "period, team, budget_eur, spent_eur, commitments_eur, consumption_rate_pct",
        },
        {
          donnee: "Taux d'accès à la formation",
          source: "LMS/LXP, SIRH",
          extraction: "Exports inscrits/achetés, API /enrollments /completions",
          exemples_logiciels: "Cornerstone, 360Learning, Docebo, Moodle",
          champs_typiques: "period, team, headcount, trainees, access_rate_pct, avg_hours_per_trainee",
        },
        {
          donnee: "Taux de promotion interne",
          source: "SIRH Carrière",
          extraction: "Export mouvements, API /promotions",
          exemples_logiciels: "Workday, SAP SF, Oracle HCM",
          champs_typiques: "period, team, eligible, promoted, promotion_rate_pct, median_time_to_promo_months",
        },
        {
          donnee: "Mobilité interne",
          source: "SIRH/ATS interne",
          extraction: "Export candidatures internes, API /job_changes",
          exemples_logiciels: "Workday, Talentsoft/Cornerstone, 365Talents",
          champs_typiques: "period, from_team, to_team, moves, avg_time_in_role_months",
        },
        {
          donnee: "Verbatim entretiens pro",
          source: "Outil d'entretiens / DMS",
          extraction: "Export CSV/JSON, API /reviews",
          exemples_logiciels: "Leapsome, Lattice, Notion/SharePoint",
          champs_typiques: "interview_id, employee_id, team, date, themes[], sentiment, verbatim",
        },
      ],
      "Data SantéPrévention": [
        {
          donnee: "Inaptitudes liées à l'usure",
          source: "Registre inaptitudes, SPST",
          extraction: "Export CSV/PDF, SFTP SPST",
          exemples_logiciels: "Padoa, Medtra, Workday",
          champs_typiques: "period, team, cases, partial_aptitude, full_inaptitude, avg_tenure_years, top_causes",
        },
        {
          donnee: "Reclassements pro",
          source: "RH/SPST",
          extraction: "Export suivi reclassement",
          exemples_logiciels: "DMS RH, Workday",
          champs_typiques: "period, team, requests, approved, avg_time_to_reclass_days, success_retention_6m_pct",
        },
        {
          donnee: "Absentéisme long (>90j)",
          source: "SIRH, Paie",
          extraction: "Export absences longues",
          exemples_logiciels: "Workday, SAP SF, ADP",
          champs_typiques: "period, team, cases_90d_plus, days_total, return_to_work_rate_30d_pct, share_atmp_pct",
        },
      ],
      IndicateursIndirects: [
        {
          donnee: "Pyramide âges/anciennetés",
          source: "SIRH",
          extraction: "Export headcount",
          exemples_logiciels: "Workday, Personio",
          champs_typiques: "period, team, age_*, seniority_*",
        },
        {
          donnee: "Compétences clés critiques",
          source: "GPEC/referentiel",
          extraction: "Export référentiel, API",
          exemples_logiciels: "365Talents, AG5",
          champs_typiques: "skill, holders, open_positions, risk_level, mitigation_plan",
        },
        {
          donnee: "Turnover talents clés",
          source: "SIRH + mapping talents",
          extraction: "Export mouvements",
          exemples_logiciels: "Workday, SAP SF",
          champs_typiques: "period, population, headcount_start, leavers, leavers_voluntary, turnover_rate_pct, avg_perf_score",
        },
        {
          donnee: "Verbatim stagnation",
          source: "Enquêtes",
          extraction: "Export JSON",
          exemples_logiciels: "Qualtrics, Culture Amp",
          champs_typiques: "response_id, team, sentiment, verbatim",
        },
      ],
    },
  },
  {
    id: "axe6",
    numero: 6,
    nom: "Santé & sécurité au travail",
    categories: {
      "HR Data": [
        {
          donnee: "Taux de fréquence & gravité AT/MP",
          source: "EHS/SPST/Paie",
          extraction: "Export incidents, heures travaillées",
          exemples_logiciels: "Enablon, Quentic",
          champs_typiques: "period, unit, hours_worked_millions, atmp_count, lost_time_days, freq_rate_FR, severity_rate_SR",
        },
        {
          donnee: "Taux de cotisation AT/MP",
          source: "Organismes SS, Paie",
          extraction: "Relevés, DSN",
          exemples_logiciels: "ameli/URSSAF, ADP, Sage",
          champs_typiques: "period, naf_code, company_rate_pct, bonus_malus_adj_pct, final_rate_pct",
        },
        {
          donnee: "Absentéisme (maladie/ATMP)",
          source: "SIRH, Paie",
          extraction: "Export absences",
          exemples_logiciels: "Workday, SAP SF",
          champs_typiques: "period, team, sickness_days, atmp_days, other_days, headcount_days, absenteeism_rate_pct",
        },
        {
          donnee: "Déclarations d'inaptitude",
          source: "SPST/SIRH",
          extraction: "Export registre, DMS",
          exemples_logiciels: "Padoa, Workday",
          champs_typiques: "period, team, declared, confirmed, job_retention_after_90d_pct",
        },
      ],
      "Data SantéPrévention": [
        {
          donnee: "DUERP (risques & plan)",
          source: "EHS/DUERP",
          extraction: "Export CSV/JSON",
          exemples_logiciels: "Enablon, Quentic",
          champs_typiques: "period, unit, risks_total, critical_risks, actions_planned, actions_done, duerp_update_date",
        },
        {
          donnee: "Rapport annuel médecin",
          source: "SPST",
          extraction: "PDF/JSON synthèse",
          exemples_logiciels: "Padoa, Medtra",
          champs_typiques: "year, coverage_pct, alerts_count, key_recos, collab_with_cssct",
        },
        {
          donnee: "Études de postes",
          source: "SPST/experts",
          extraction: "Exports CSV",
          exemples_logiciels: "SPST/outils internes",
          champs_typiques: "period, unit, study_id, job, findings, reco",
        },
        {
          donnee: "Rapports d'analyse AT/MP",
          source: "EHS/SPST",
          extraction: "Export CSV",
          exemples_logiciels: "Enablon, Intelex",
          champs_typiques: "period, unit, cases_analyzed, root_causes_top, recommendations",
        },
      ],
      IndicateursIndirects: [
        {
          donnee: "Passages infirmerie",
          source: "Infirmerie",
          extraction: "Export journal",
          exemples_logiciels: "Outils infirmerie",
          champs_typiques: "period, site, visits_total, top_reasons, referrals_spst",
        },
        {
          donnee: "Verbatim enquêtes sécurité",
          source: "Plateformes",
          extraction: "Export JSON",
          exemples_logiciels: "Qualtrics, Culture Amp",
          champs_typiques: "response_id, platform, sentiment, verbatim",
        },
        {
          donnee: "Taux réalisation plan DUERP",
          source: "DUERP/EHS",
          extraction: "Export suivi actions",
          exemples_logiciels: "Enablon, Quentic",
          champs_typiques: "period, unit, actions_planned, actions_done, completion_rate_pct, late_actions, on_track_actions",
        },
        {
          donnee: "Signaux faibles (sécurité)",
          source: "Enquêtes/observations",
          extraction: "CSV/JSON",
          exemples_logiciels: "Pulse, Forms",
          champs_typiques: "period, team, fatigue_pct, somatic_complaints_pct, stress_signals_pct, free_text",
        },
      ],
    },
  },
  {
    id: "axe7",
    numero: 7,
    nom: "Communication & Collaboration",
    categories: {
      "Collaboration Data": [
        {
          donnee: "Volume de messages équipe",
          source: "Slack, Microsoft Teams, Google Chat",
          extraction: "Export JSON Slack ; API Teams /messages ; API Google Chat",
          exemples_logiciels: "Slack Export API, Microsoft Teams Analytics, Google Workspace Admin SDK",
          champs_typiques: "user_id, channel, timestamp, message_count, thread_count, period",
        },
        {
          donnee: "Top contributeurs communication",
          source: "Analyse exports Slack/Teams",
          extraction: "Agrégation messages par user_id ; API /users /analytics",
          exemples_logiciels: "Slack Analytics, Microsoft Viva Insights, custom analytics",
          champs_typiques: "user_id, user_name, total_messages, reactions_received, channels_active, engagement_score",
        },
        {
          donnee: "Activité par canal de communication",
          source: "Slack channels, Teams channels",
          extraction: "Export par canal ; API /channels /stats",
          exemples_logiciels: "Slack API, Teams Graph API",
          champs_typiques: "channel_id, channel_name, message_count, member_count, peak_hours, engagement_rate",
        },
        {
          donnee: "Patterns horaires d'activité",
          source: "Logs timestamp des messages",
          extraction: "Analyse temporelle des exports ; API /analytics /hourly",
          exemples_logiciels: "Slack Analytics, Microsoft Viva Insights, custom time-series analysis",
          champs_typiques: "hour, day_of_week, message_count, active_users, peak_indicator, timezone",
        },
        {
          donnee: "Tendances mensuelles collaboration",
          source: "Historique messages agrégés",
          extraction: "Export historique mensuel ; API /analytics /monthly",
          exemples_logiciels: "Slack workspace analytics, Teams usage reports",
          champs_typiques: "month, year, total_messages, active_users, new_channels, growth_rate_pct",
        },
        {
          donnee: "Engagement et réactions",
          source: "Métriques réactions Slack/Teams",
          extraction: "Export reactions ; API /messages /reactions",
          exemples_logiciels: "Slack reactions API, Teams reactions analytics",
          champs_typiques: "message_id, user_id, reaction_type, reaction_count, sentiment_score, engagement_index",
        },
        {
          donnee: "Participation cross-canaux",
          source: "Matrix user × channel",
          extraction: "Agrégation multi-canaux ; graph analysis",
          exemples_logiciels: "Network analysis tools, custom dashboards",
          champs_typiques: "user_id, channels_list, cross_channel_score, bridge_score, isolation_risk",
        },
      ],
      "Communication Health": [
        {
          donnee: "Taux de réponse et délais",
          source: "Analyse threads et timestamps",
          extraction: "Calcul delta timestamps ; API /threads /response_time",
          exemples_logiciels: "Custom analytics, Slack thread analysis",
          champs_typiques: "thread_id, response_time_minutes, participants, resolution_status, escalation_flag",
        },
        {
          donnee: "Distribution charge communication",
          source: "Métriques messages par utilisateur",
          extraction: "Statistiques descriptives messages/user",
          exemples_logiciels: "BI tools (Power BI, Tableau), custom scripts",
          champs_typiques: "period, mean_messages, median_messages, std_dev, top_10_pct_share, gini_coefficient",
        },
        {
          donnee: "Silos de communication détectés",
          source: "Graph analysis réseaux",
          extraction: "Détection communautés ; graph clustering",
          exemples_logiciels: "NetworkX, Gephi, custom graph algorithms",
          champs_typiques: "cluster_id, cluster_size, inter_cluster_connectivity, silo_risk_score, members_list",
        },
      ],
    },
  },
];

